import React, { memo, useCallback } from "react";

import { useAxiomState } from "__AxiomComponents/AxiomHooks/AxiomHooks";

import HawkeyeSearchMenu from "./HawkeyeSearchMenu";
import Icon from "../Icons/Icon";

import "./HawkeyeSearch.scss";
import { useGetCurrentPageName } from "./HawkeyeSearchHooks.js";

function HawkeyeSearch(props) {
  const { dashboard, pages, onSelection, currentPageIndex, appSettings } = props;

  const [state, dispatch] = useAxiomState(
    {
      isSelectionMenuOpen: false,
    },
    props.appName,
    props.appID,
    "HawkeyeSearch",
    props.componentID
  );

  const toggleSelectionMenu = useCallback(() => {
    dispatch((state) => ({ isSelectionMenuOpen: !state.isSelectionMenuOpen }));
  }, [dispatch]);

  const pageName = useGetCurrentPageName(pages, currentPageIndex);

  return (
    <div className="hawkeye-search">
      <a className="hawkeye-search-menu-trigger" onClick={toggleSelectionMenu}>
        {appSettings && appSettings.interchangeIconAndQuestion && (
          <p className="hawkeye-search-placeholder">
            <Icon icon="ICON_SEARCH" className="hawkeye-search-icon" />
            <span>
              {AxiomAPIs.translate("Load questions related to")}&nbsp;
              <b>{AxiomAPIs.translate(pageName)}</b>
            </span>
          </p>
        )}
        {(!appSettings || (appSettings && !appSettings.interchangeIconAndQuestion)) && (
          <p className="hawkeye-search-placeholder">
            <span>
              Questions related to&nbsp;
              <b>{dashboard}</b>
              &nbsp;-&nbsp;
              <b>{AxiomAPIs.translate(pageName)}</b>
            </span>
            <Icon icon="ICON_SEARCH" className="hawkeye-search-icon" />
          </p>
        )}
      </a>
      {state.isSelectionMenuOpen && (
        <HawkeyeSearchMenu
          isOpen={state.isSelectionMenuOpen}
          pages={pages}
          currentPageIndex={currentPageIndex}
          onSelection={onSelection}
          closeMenu={toggleSelectionMenu}
          appName={props.appName}
          appID={props.appID}
          componentID={props.componentID}
          appSettings={appSettings}
        />
      )}
    </div>
  );
}

export default memo(HawkeyeSearch);
